import { isNumber as lo_isNumber } from 'es-toolkit/compat';
import { isString as lo_isString } from 'es-toolkit';

export function convertNumberOrNull(value: Nilish<number | string | unknown>): Nullable<number> {
    let val = null;

    if (lo_isNumber(value)) {
        val = value;
    } else if (lo_isString(value)) {
        const n = parseFloat(`${value}`);

        if (!isNaN(n)) {
            val = n;
        }
    }

    return val;
}
